/*DAY OFF STATISTICS*/
Vue.component('dayoffstatistics', {
    template:'#dayoffstatistics-template',

    data:function(){
        return{
            list: [],
            searchString:'',
            modal:'',
        };
    },
    created:function(){


        activeInstance = this;
        //activeInstance.modal = $('body').find('#create_user_modal').html();

        showLoadingOverlay();
        Vue.http.get(baseURL+'/statistics/users/off_time',function(response){
            $('body').LoadingOverlay("hide");
            activeInstance.list=response;

            setTimeout(function(){
                var $table = $('.fixed_header_table');
                $table.floatThead({
                    top:70
                });
            },200);
            /*
            setTimeout(function() {
                var running_footable = FooTable.get(".responsive-table");
                if (running_footable) {
                    running_footable.destroy();
                }

                $('.responsive-table').footable();
            },50);
            */


        }).bind(this);


    },

    methods:{

    }
});